import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export const FinalCTA = () => {
  return <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-teal text-white" data-id="element-100">
      <div className="container-custom text-center" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-102">
          <h2 className="text-3xl font-bold mb-6" data-id="element-103">
            Ready to bring order to your daily work?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-104">
            Join thousands of teams who have simplified their workflows with
            Daily Serve.
          </p>
          <Link to="/trial" className="inline-block bg-white text-brand-blue font-medium py-3 px-8 rounded-md shadow-sm hover:bg-opacity-90 transition-all duration-200" data-id="element-105">
            Start free trial today
          </Link>
          <p className="mt-4 text-sm text-white text-opacity-80" data-id="element-106">
            No credit card required. 14-day free trial.
          </p>
        </motion.div>
      </div>
    </section>;
};